if (!customElements.get('localization-picker')) {
  customElements.define(
    'localization-picker',
    class LocalizationPicker extends HTMLElement {
      connectedCallback() {
        this.trigger = this.querySelector('.loc-picker__trigger');
        this.panel = this.querySelector('.loc-picker__panel');
        this.search = this.querySelector('[data-loc-search]');
        this.empty = this.querySelector('[data-loc-empty]');
        this.countries = Array.from(this.querySelectorAll('.loc-picker__country'));
        this.isDrawer = this.classList.contains('loc-picker--drawer');
        this.isFooter = this.classList.contains('loc-picker--footer');

        this.trigger.addEventListener('click', () => (this.isOpen() ? this.close() : this.open()));
        this.querySelectorAll('[data-loc-close]').forEach((button) =>
          button.addEventListener('click', () => this.close(true))
        );
        if (this.search) this.search.addEventListener('input', () => this.filter());

        this.addEventListener('keyup', (event) => {
          if (event.code === 'Escape' && this.isOpen()) {
            event.stopPropagation();
            this.close(true);
          }
        });

        this.onOutsideClick = (event) => {
          if (!this.contains(event.target)) this.close();
        };
      }

      isOpen() {
        return !this.panel.hasAttribute('hidden');
      }

      open() {
        this.panel.removeAttribute('hidden');
        this.trigger.setAttribute('aria-expanded', 'true');
        this.classList.add('is-open');
        if (!this.isDrawer) document.addEventListener('click', this.onOutsideClick);
        // Keeps the sticky header from hiding itself while the panel is open
        const header = document.querySelector('.header-wrapper');
        if (header) header.preventHide = true;

        if (this.isFooter) this.makeRoomAbove();

        // Focus the search on desktop only; on touch it would pop the keyboard over the list
        const focusTarget = this.isDrawer
          ? this.panel.querySelector('[data-loc-close]')
          : window.matchMedia('(hover: hover)').matches && this.search;
        if (focusTarget) focusTarget.focus({ preventScroll: true });
      }

      // The footer panel floats upward. At the bottom of the page there can be less room
      // above the trigger than the panel needs, and the fixed header would cover the top
      // of it, so scroll up just enough to show it whole. Scrolling up also slides the
      // fixed category bar (sub-header.js) back in under the header, so count it too.
      makeRoomAbove() {
        const header = document.querySelector('.header-wrapper');
        const subHeader = document.querySelector('.js-sub-header');
        const covered =
          (header ? Math.max(0, header.getBoundingClientRect().bottom) : 0) +
          (subHeader ? subHeader.offsetHeight : 0);
        const overlap = covered + 12 - this.panel.getBoundingClientRect().top;
        if (overlap > 0) window.scrollBy({ top: -overlap, behavior: 'smooth' });
      }

      close(returnFocus = false) {
        if (!this.isOpen()) return;
        this.panel.setAttribute('hidden', '');
        this.trigger.setAttribute('aria-expanded', 'false');
        this.classList.remove('is-open');
        document.removeEventListener('click', this.onOutsideClick);
        const header = document.querySelector('.header-wrapper');
        if (header) header.preventHide = false;

        if (this.search && this.search.value) {
          this.search.value = '';
          this.filter();
        }
        if (returnFocus) this.trigger.focus();
      }

      filter() {
        const query = this.search.value.trim().toLowerCase();
        let visible = 0;
        this.countries.forEach((item) => {
          const match = !query || item.dataset.name.indexOf(query) > -1;
          item.hidden = !match;
          if (match) visible++;
        });
        this.classList.toggle('is-filtering', query.length > 0);
        if (this.empty) this.empty.hidden = visible > 0;
      }
    }
  );
}
